import { Icon } from '@pwc/pwc-deals-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { createReportPath } from '../../services/urlService';
import './ReportBuilderLink.scss';

const ReportBuilderLink = ({ projectId }) => {
  const { t } = useTranslation();
  return (
    <Link to={createReportPath(projectId)} className="report-builder-link">
      <Icon
        name="report"
        width={24}
        className="report-builder-link__icon fill icon-orange"
      />
      {t('reportBuilder')}
    </Link>
  );
};

export default ReportBuilderLink;
